<template>
  <div class="customMenu">
    <div class="refresh"><i class="el-icon-refresh"></i>刷新</div>
    <div class="content">
        <div class="leftContent">
            <img src="@/assets/images/iphone1.png" alt="">
            <div class="menuContent">
              <div class="keyboard"><img src="@/assets/images/keyboard.png" alt=""/></div>
              <div class="commonList">
                  <div class="commonListItem" :key="index" v-for="(item,index) in commonList_0" @click="subMenuClick(0,item,index,$event)">{{item.commonListItemName}}</div>
              </div>
              <div class="commonList">
                  <div class="commonListItem" :key="index" v-for="(item,index) in commonList_1" @click="subMenuClick(1,item,index,$event)">{{item.commonListItemName}}</div>
              </div>
              <div class="commonList">
                  <div class="commonListItem" :key="index" v-for="(item,index) in commonList_2" @click="subMenuClick(2,item,index,$event)">{{item.commonListItemName}}</div>
              </div>
            </div>
        </div>
        <div class="rightContent">
            <div class="rightContentTitle"><div style="color:#666666">自定义菜单</div><div @click="omitMenu()">删除菜单</div></div>
            <div class="rightContentSteps">
              <div class="stepItem">
                <div class="stepTitle">第一步：在左侧选择需要编辑的菜单，并对菜单进行命名</div>
                <div class="stepContent"><label>{{currentRightContent.isMainMenu?'主菜单名称':'子菜单名称'}}</label><el-input v-model="currentRightContent.commonListItemName" placeholder='请输入菜单名称' maxlength="6" show-word-limit></el-input></div>

              </div>
              <div v-show="!currentRightContent.isMainMenu" class="stepItem">
                <div class="stepTitle">第二步：设置点击该菜单所触发的动作事件,如：领取卡券<span style="float:right;color:#409EFF;cursor:pointer" @click="actionClassifyVisible=false">修改菜单</span></div>
                <div v-if="!actionClassifyVisible" class="stepContent">
                  <div class="actionContainer" >
                    <div @click="getActionDetailContent('发送消息')">
                      <div class="imgArea"><img src="../../../assets/images/messageSend.png" alt=""></div>
                      <div class="actionName">发送消息</div>
                    </div>
                  </div>
                  <div class="actionContainer" >
                    <div @click="getActionDetailContent('网址链接')">
                      <div class="imgArea"><img src="../../../assets/images/url.png" alt=""></div>
                      <div class="actionName">网址链接</div>
                    </div>
                  </div>
                  <div class="actionContainer" >
                    <div @click="getActionDetailContent('功能入口')">
                      <div class="imgArea"><img src="../../../assets/images/more.png" alt=""></div>
                      <div class="actionName">功能入口</div>
                    </div>
                  </div>
                  <div class="actionContainer" >
                    <div @click="getActionDetailContent('其他小程序入口')" style="text-align:center">
                       <div class="imgArea"><img src="../../../assets/images/more.png" alt=""></div>
                       <div class="actionName">其他小程序入口</div>
                    </div>
                  </div>
                </div>
                <div v-else class="stepContentDetail">
                  <div v-if='currentActionType=="发送消息"' class="oneAction">
                    <div class="detailTitle">
                      <div style="display:flex" :key="index" v-for="(tabName,index) in currentRightContent.secondStep.sendMessage.tabList">
                        <div :class="currentSecondTabIndex===index?'detailTitleText':'detailTitleTextNo'" @click="secondStepTabClick(tabName,index)">{{tabName}}</div><div class="divider"></div>
                      </div>
                      <!-- <div class="detailTitleText">其他信息</div> -->
                    </div>
                    <div v-show="currentSecondTabIndex===0" class="detailContent">
                      <div class="uploadArea">
                        <div style="margin-bottom:10px">上传图片：</div>
                        <div><el-button type="warning" @click="uploadImg()">上传图片</el-button><el-button type="warning">删除</el-button></div>
                      </div>
                      <div class="imgArea">
                        <img :src="currentRightContent.secondStep.sendMessage.imgUrl" />
                      </div>
                    </div>
                    <div v-show="currentSecondTabIndex===1" class="detailContent">
                      {{currentRightContent.secondStep.sendMessage.otherInfo}}
                    </div>
                  </div>
                  <div v-if='currentActionType=="网址链接"' class="oneAction">
                    <div class="stepContent">
                      <div>
                        <label style="display:inline-block;width:80px">页面网址</label><el-input v-model="currentRightContent.secondStep.webLink" placeholder='例如：https://www.xxxxxx.com'></el-input>
                      </div>

                      <div style="margin-top:10px">
                        <label style="display:inline-block;width:80px"></label><el-button type='primary' @click="obtainMembershipCard()">获取会员卡地址</el-button> 
                      </div>
                                          
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div class="saveAndIssue">
          <el-button type='primary' @click="saveAndIssue()">保存并发布</el-button>
        </div>
    </div>

    <!-- 选择功能入口 -->
    <el-dialog
      title="选择功能入口"
      :visible.sync="functionEntranceVisible"
      width="20%"
      custom-class="functionEntranceBox"
    >
      <div class="functionEntranceContent">
        <div class="oneEntrance">
          <div style="width:24%">小程序商城入口</div>
          <div style="width:60%">点击设置小程序商城的入口（小程序需要和公众号绑定）</div>
          <div>
            <el-button v-if="currentRightContent.secondStep?currentRightContent.secondStep.funOfEntrance.entranceId==='applet':false" type='primary'>已选择</el-button>
            <el-button v-else type='default' @click="selectEntranc('applet')">选择</el-button>
          </div>
        </div>
        <div class="oneEntrance">
          <div style="width:24%">积分商城入口</div>
          <div style="width:60%">商家开启积分商城之后可以使用该入口功能</div>
          <div>
            <el-button v-if="currentRightContent.secondStep?currentRightContent.secondStep.funOfEntrance.entranceId==='integral':false" type='primary'>已选择</el-button>
            <el-button v-else type='default' @click="selectEntranc('integral')">选择</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="functionEntranceVisible = false">取 消</el-button>
        <el-button type="primary" @click="functionEntranceVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 填写其他小程序 -->
    <el-dialog
      title="填写其他小程序"
      :visible.sync="otherAppletEntranceVisible"
      width="26%"
      custom-class="otherAppletEntranceBox"
    >
      <div class="otherAppletEntranceContent">
        <el-form label-width='28%'>
          <el-form-item v-if='currentRightContent.secondStep' label='小程序appID'>
            <el-input v-model="currentRightContent.secondStep.otherAppletEntrance.appletId"></el-input>
          </el-form-item>
          <el-form-item v-if="currentRightContent.secondStep" label='小程序入口地址'>
            <el-input v-model="currentRightContent.secondStep.otherAppletEntrance.appletEntranceUrl"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="otherAppletEntranceVisible = false">取 消</el-button>
        <el-button type="primary" @click="otherAppletEntranceVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../../config/api';
// {
//   commonListItemName:'微校园',
//   commonListItemId:'A01'//决定了是否市添加按钮
//   isMainMenu:true,//是否是主菜单固定
//   secondStep:{
//     sendMessage:{},
//     webLink:'',
//     funOfEntrance:{},
//     otherAppletEntrance:{}
//   }
// }
export default {
  data(){
    return{
      menuName:"",
      currentEvent:null,//当前的点击事件
      currentRightContent:{},
      currentActionType:'',//当前点击的何种动作类型
      functionEntranceVisible:false,
      otherAppletEntranceVisible:false,
      actionClassifyVisible:false,
      currentSecondTabIndex:0,//第二步的tab选中项的tabIndex
      currentItemIndex_x:-1,//当前所处那个功能列下的某个小项的索引
      currentCommonList_x:[],//当前点击所处哪个功能列
      commonList_0:[//公众号第一列功能集合
        {
          commonListItemName:'微校园',
          commonListItemId:'A01',
          isMainMenu:true,
          secondStep:{
            sendMessage:{
              tabList:['图片','其他信息'+0],
              imgUrl:'../../../../static/c.png',
              otherInfo:'这是其它信息'
            },
            webLink:'',
            funOfEntrance:{
              entranceId:''
            },
            otherAppletEntrance:{
              appletId:'',
              appletEntranceUrl:''
            }
          }
        },
        {
          commonListItemName:'往期精彩',
          commonListItemId:'A02',
          isMainMenu:false,
          secondStep:{
            sendMessage:{
              tabList:['图片','其他信息'],
              imgUrl:'../../../../static/c.png',
              otherInfo:'这是其它信息'
            },
            webLink:'www.dianboy.com',
            funOfEntrance:{
              entranceId:'applet'
            },
            otherAppletEntrance:{
              appletId:'',
              appletEntranceUrl:''
            }
          }
        },
        {
          commonListItemName:'信息公告',
          commonListItemId:'A03',
          isMainMenu:false,
          secondStep:{
            sendMessage:{
              tabList:['图片','其他信息2'],
              imgUrl:'../../../../static/c.png',
              otherInfo:'这是其它信息'
            },
            webLink:'',
            funOfEntrance:{
              entranceId:'integral'
            },
            otherAppletEntrance:{
              appletId:'',
              appletEntranceUrl:''
            }
          }
        },
        {
          commonListItemName:'+添加子菜单',
          commonListItemId:'',
          isMainMenu:false,
        },
      ],
      commonList_1:[//公众号第二列功能集合
        {
          commonListItemName:'+添加子菜单',
          commonListItemId:'',
          isMainMenu:false,
        }
      ],
      commonList_2:[//公众号第三列功能集合
        {
          commonListItemName:'+添加子菜单',
          commonListItemId:'',
          isMainMenu:false,
        }
      ]
    }
  },
  created(){
    this.publicNumMenuQuery();
  },
  methods:{
    //查询自定义菜单配置
    publicNumMenuQuery(){
      let url=api.system.publicNumMenuQuery;
      this.$axios.fetchPost(url).then((res)=>{
        console.log('查的自定义菜单',res)
        if(res.code===200){
          this.resShiftLocalStructure(res.data)
        }else{
          this.$message.error(res.errorMsg);
        }
      })
    },
    resShiftLocalStructure(data){
      if(data.button.length===0){//没有任何主菜单初始化数据
        for(let i=0;i<3;i++){
          let commonList_x='commonList_'+i;
          this[commonList_x].push(
            {
              commonListItemName:'+添加子菜单',
              commonListItemId:'',
              isMainMenu:false
            }
          )
        }  
        return    
      }

      this.commonList_0=[];
      this.commonList_1=[];
      this.commonList_2=[];
      for(let j=0;j<data.button.length;j++){
          let commonList_x='commonList_'+j;
          this[commonList_x].push(
            {
              commonListItemName:data.button[j].name,
              commonListItemId:'A01',
              isMainMenu:false,
              secondStep:{
                sendMessage:{
                  tabList:['图片','其他信息'+0],
                  imgUrl:'../../../../static/c.png',
                  otherInfo:'这是其它信息'
                },
                webLink:'',
                funOfEntrance:{
                  entranceId:''
                },
                otherAppletEntrance:{
                  appletId:'',
                  appletEntranceUrl:''
                }
              }
            },
            {
              commonListItemName:'+添加子菜单',
              commonListItemId:'',
              isMainMenu:false
            }
          )
      }
               
    },
    //保存并发布
    saveAndIssue(){

    },
    //选择功能入口
    selectEntranc(entranceType){
      console.log();
      this.currentRightContent.secondStep.funOfEntrance.entranceId=entranceType;
    },
    //获取会员卡地址
    obtainMembershipCard(){
    
    },
    //获取动作细节配置内容
    getActionDetailContent(actionType){
      this.currentActionType=actionType;
      switch (actionType) {
        case '发送消息':
          this.actionClassifyVisible=true;
          break;
        case '网址链接':
          this.actionClassifyVisible=true;
          break;
        case '功能入口':
          this.actionClassifyVisible=false;
          this.functionEntranceVisible=true;
          break;
        case '其他小程序入口':
          this.actionClassifyVisible=false;
          this.otherAppletEntranceVisible=true;
          break;     
        default:
          break;
      }
    },
    //第二步中的tabList点击事件
    secondStepTabClick(tabListItem,index){
      this.currentSecondTabIndex=index;
    },
    myUploadImg(imgArea,imgWidth,imgHeight){  
      //创建input文件框
      this.inputNode=document.createElement('input');
      this.inputNode.type='file';
      this.inputNode.click();

      var timer=setInterval(() => {
        if(this.inputNode.files[0]){
          let file=this.inputNode.files[0];//获取文件，就好比其它input框要获取value一个道理 
          console.log('我的文件呢',file)

          let reader=new FileReader();
          let fileSrc;//转化成src数据源的量
          let newNode;

          reader.onload=(e)=>{
            console.log(e);
            var fileType=file.name.split(".")[1];
            switch(fileType){
                  case 'png':
                  fileSrc=URL.createObjectURL(file);
                  /*自定义img标签使用*/
                  // newNode=document.createElement("img");
                  // newNode.src=fileSrc;
                  // newNode.style.width=imgWidth;
                  // newNode.style.height=imgHeight;
                  // if(imgArea.childNodes[0]!=undefined)
                  //     imgArea.childNodes[0].parentNode.replaceChild(newNode,imgArea.childNodes[0]);
                  // else
                  //   imgArea.appendChild(newNode);   
                  
                  /*实际业务需求*/
                  this.currentRightContent.secondStep.sendMessage.imgUrl=fileSrc;
                  console.log('当前右侧数据呢',this.currentRightContent.secondStep)
                    break;
                  case "jpg":
                    //fileSrc=e.target.result;也可以用下面的方法本地转换成URL
                    fileSrc=URL.createObjectURL(file);
                    console.log("URL=>",fileSrc);
                    newNode=document.createElement("img");
                    newNode.src=fileSrc;
                    newNode.style="width:212px;height:316px";
                    if(imgView.childNodes[0]!=undefined)
                        imgView.childNodes[0].parentNode.replaceChild(newNode,imgView.childNodes[0]);
                    else
                        imgView.appendChild(newNode);
                    break;
                  case "mp4":
                    fileSrc=e.target.result;
                    newNode=document.createElement("video");	
                    newNode.src=fileSrc	;
                    newNode.style="width:300px;height:300px";
                    newNode.play();
                    newNode.controls=true;
                    newNode.loop=true;
                    if(imgView.childNodes[0]!=undefined)
                        imgView.childNodes[0].parentNode.replaceChild(newNode,imgView.childNodes[0]);
                    else
                        imgView.appendChild(newNode);
                    break;
                    default :
                      alert("暂未定义此类型文件");
                      break;						   
            }
            
          }
          reader.readAsDataURL(file);
          clearInterval(timer)
          
          //把imgUrl保存
          
        }else{
          console.log('没file')
        }
      }, 1000);
    },
    //上传图片
    uploadImg(){
      let imgArea=document.querySelector('.rightContent .rightContentSteps .stepItem .stepContentDetail .detailContent .imgArea');
      this.myUploadImg(imgArea,'100px','100px')
    },
    //删除菜单
    omitMenu(){
      if(this.currentItemIndex_x===0){
        this.$message({
          message:'不允许删除主菜单!',
          type:'warning'
        })
        return;
      }
      this.$confirm('确定要删除这个子菜单？删除后不可恢复', '温馨提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'info'
      }).then(() => {
        this.currentCommonList_x.splice(this.currentItemIndex_x,1);
        //删除后显示主菜单内容
        this.leftShowRight(this.currentCommonList_x,this.currentCommonList_x[0],0);

        // //删除后如果当前列最后一项不是“添加子菜单”则在该列补齐一个“添加子菜单”功能框
        if(this.currentCommonList_x[this.currentCommonList_x.length-1].commonListItemId){
          this.currentCommonList_x.push({commonListItemName:'+添加子菜单',commonListItemId:''});
        }

        //高亮当前主菜单显示的主菜单
        for(let i=0;i<this.currentEvent.target.parentNode.childNodes.length;i++){
          this.currentEvent.target.parentNode.childNodes[i].style.border='1px solid';
        }
        this.currentEvent&&(this.currentEvent.target.parentNode.childNodes[0].style.border='1px solid #409EFF');
      }).catch(() => {
      }); 
    },
    //左侧任意方框点击的变化及右侧显示
    leftShowRight(commonListItem_x,item,itemIndex){
        //给当前所处功能列赋值浅拷贝已备同步操作删除
        this.currentCommonList_x=commonListItem_x;
        this.currentItemIndex_x=itemIndex;

        //显示第二步细节内容前先展示第二步分类
        this.actionClassifyVisible=false;

        if(item.commonListItemId){//有id说名不是"添加子菜单"的点击
            console.log('是子菜单')
            //此处填写加载右侧数据
            //如上保存当前右侧数据并显示右侧数据
            this.currentRightContent=item;
        }else{//"添加子菜单"
            //点击的"添加子菜单"，判断其是否是最后一个，是最后一个则加载右侧数据并且不允许在添加
            if(commonListItem_x.length===6){
                commonListItem_x[5].commonListItemName='',
                commonListItem_x[5].commonListItemId=String(itemIndex),
                commonListItem_x[5].isMainMenu=commonListItem_x.length===0?true:false
                commonListItem_x.splice(5,1);
                //放入最后一个置空的初始化数据
                commonListItem_x.push(
                  {  
                    commonListItemName:'',
                    commonListItemId:String(itemIndex),
                    isMainMenu:commonListItem_x.length===0?true:false,
                    secondStep:{
                      sendMessage:{
                        tabList:['图片','其他信息'+itemIndex],
                        imgUrl:'../../../../static/c.png',
                        otherInfo:'这是其它信息'
                      },
                      webLink:'',
                      funOfEntrance:{
                        entranceId:''
                      },
                      otherAppletEntrance:{
                        appletId:'',
                        appletEntranceUrl:''
                      }
                    }
                  }
                )
                //加载右侧数据
                return;
            }
            commonListItem_x.splice(itemIndex,1);
            //放入一个置空的初始化数据
            commonListItem_x.push(
                {  
                  commonListItemName:'',
                  commonListItemId:String(itemIndex),
                  isMainMenu:commonListItem_x.length===0?true:false,
                  secondStep:{
                    sendMessage:{
                      tabList:['图片','其他信息'+itemIndex],
                      imgUrl:'../../../../static/c.png',
                      otherInfo:'这是其它信息'
                    },
                    webLink:'',
                    funOfEntrance:{
                      entranceId:''
                    },
                    otherAppletEntrance:{
                      appletId:'',
                      appletEntranceUrl:''
                    }
                  }
                },{
                  commonListItemName:'+添加子菜单',
                  commonListItemId:''                  
                }
            )
        }    
    },
    subMenuClick(parentMenuId,item,index,event){
      console.log('所有的方框',document.querySelectorAll('.commonListItem'))
      this.currentEvent=event;
      //如果点击的是“添加子菜单”按钮则不变样式
      if(!item.commonListItemId){}
      else{
        //将所有方框的border样式去掉
        for(let i=0;i<document.querySelectorAll('.commonListItem').length;i++){
          document.querySelectorAll('.commonListItem')[i].style.border='1px solid';
        }
        //当前点击框上色
        event.target.style.border='1px solid #409EFF';
      }

      switch (String(parentMenuId)) {
          case '0'://来自第一个列下的相关操作
              this.leftShowRight(this.commonList_0,item,index);
              console.log('当前列的情况',this.commonList_0)
              break;
          case '1':
              this.leftShowRight(this.commonList_1,item,index)
              break;
          case '2':
              this.leftShowRight(this.commonList_2,item,index)
              break;
          default:
              break;
      }
    }
  }
}
</script>

<style scoped>
.customMenu{
    height: calc(100vh - 60px);
    background-color: #ffffff;
    padding: 0px 20px;
}
.divider{
  border:1px solid #E6E6E6;
  border: 1px solid #E6E6E6;
  margin: 10px 0px;
}
.customMenu .refresh{
    color:#666666;
    text-align: right;
}
.customMenu .content{
  width: 100%;
  height: auto;
  border:1px solid #ddd;
  padding: 30px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}

.content .leftContent{
  border:1px solid #ddd;
  width: 300px;
  height: 500px;
  position: relative;
  box-sizing: border-box;
}
.content .leftContent img{
  width: 300px;
  height: 500px;
}
.content .leftContent .menuContent{
    position: absolute;
    bottom: 0px;
    left: 0px;
    z-index: 1000;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 2px;
    align-items: flex-end
}
.content .leftContent .menuContent .keyboard{
    width: 40px;
    height: 38px;
    border:1px solid #ddd;
    text-align: center;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
}
.content .leftContent .menuContent .keyboard img{
    width: 30px;
    height: 17px;
}

.content .leftContent .menuContent .commonList{
    width:83px;
    /* height: 38px; */
    height: 300px;
    border:1px solid #ddd;
    display: flex;
    flex-flow: column-reverse nowrap;
}
.content .leftContent .menuContent .commonList .commonListItem{
    border:1px solid #ddd;
    height: 38px;
    cursor: pointer;
    margin-top: 4px;

    color: #C6C6C6;
    font-size: 12px;
    text-align: center;
    line-height: 38px;
}

.content .rightContent{
  width: 80%;
  height: 500px;
  border: 1px solid #ddd;
}

.content .saveAndIssue{
  margin-left: auto;
  margin-top: 16px;
}

.rightContent .rightContentTitle{
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    padding:0px 15px 0px 15px;
    line-height: 45px;

    font-size: 16px;
    border-bottom: 1px solid #ddd;
}
.rightContent .rightContentTitle div:nth-of-type(2){
  cursor: pointer;
  color:#409EFF;
}
.rightContent .rightContentSteps{

    padding: 15px;
}
.rightContent .rightContentSteps .stepItem{
  color:#666666;
}
.rightContent .rightContentSteps .stepItem .stepContent{
  padding-left: 54px;
  margin-top: 40px;
  margin-bottom: 40px;
  display: flex;
  flex-flow: row wrap;

  font-size:16px;
  line-height: 30px;
}
.rightContent .rightContentSteps .stepItem .stepContentDetail{
  border:1px solid #E3E3E3;
  width: 498px;
}
.rightContent .rightContentSteps .stepItem .stepContentDetail .detailTitle{
  height:40px;
  border-bottom:1px solid #E3E3E3;
  display: flex;
}
.rightContent .rightContentSteps .stepItem .stepContentDetail .detailContent{
  padding: 20px 20px 10px 20px;
  height:130px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
}
.rightContent .rightContentSteps .stepItem .stepContentDetail .detailContent .uploadArea{
  display: flex;
  flex-flow: column;
  justify-content: center;
}
.rightContent .rightContentSteps .stepItem .stepContentDetail .detailContent .imgArea{
  width: 100px;
  height: 100px;
  margin-left: 10px;
}
.rightContent .rightContentSteps .stepItem .stepContentDetail .detailContent .imgArea img{
  width:100px;
  height:100px;
}
.rightContent .rightContentSteps .stepItem .stepContentDetail .detailTitle .detailTitleText{
  color: #409EFF;
  line-height: 37px;
  display: inline-block;
  border-bottom: 3px solid #409EFF;
  margin: 0px 15px 0px 15px;
  cursor: pointer;
}
.rightContent .rightContentSteps .stepItem .stepContentDetail .detailTitle .detailTitleTextNo{
  color: #000000;
  line-height: 37px;
  display: inline-block;
  margin: 0px 15px 0px 15px;
  cursor: pointer;
}
.rightContent .rightContentSteps .stepItem .stepContent label{
  margin-right: 20px;
}

.rightContent .rightContentSteps .stepItem .actionContainer{
  width:150px;
  height:100px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  font-size:14px;
}
.rightContent .rightContentSteps .stepItem .actionContainer>div{
  cursor: pointer;
}
.rightContent .rightContentSteps .stepItem .actionContainer .imgArea img{
  height:38px;
  width: 47px;
}
.rightContent .rightContentSteps .stepItem .actionContainer .actionName{
  margin-top: 10px;
}

.functionEntranceContent .oneEntrance{
  border-bottom: 1px solid #dddddd;
  padding: 10px 20px;
}
.functionEntranceContent .oneEntrance div{
  display: inline-block;
}

.customMenu>>>.otherAppletEntranceBox{
  min-width: 0px;
}
</style>


// WEBPACK FOOTER //
// src/page/system/wechat/menu.vue